import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DIALOG_DATA, DialogRef } from '../dialog';
import { SignatureStatus } from '../signature-popover/signature-popover.entities';
import {
  FileComparisonDialogInputData,
  FilePreview,
} from './file-comparison-dialog.entities';

@Component({
  selector: 'app-file-comparison-dialog',
  templateUrl: './file-comparison-dialog.component.html',
  styleUrls: ['./file-comparison-dialog.component.scss'],
})
export class FileComparisonDialogComponent {
  readonly OPTIONS = booleanOptions;

  originalFile: FilePreview;
  downloadedFile: FilePreview;
  status: string = null;
  signerName: string = null;
  signerCPF: string = null;
  signerCNPJ: string = null;
  answers: FormGroup;
  requirementsAreMet: boolean = null;

  constructor(
    private dialogRef: DialogRef<FileComparisonDialogComponent>,
    @Inject(DIALOG_DATA) public data: FileComparisonDialogInputData,
    private fb: FormBuilder
  ) {
    this.originalFile = data.originalFile;
    this.downloadedFile = data.downloadedFile;
    this.status = data.status;
    this.signerName = data.signerName;
    this.signerCPF = data.signerCPF;
    this.signerCNPJ = data.signerCNPJ;

    (this.answers = this.fb.group({
      validDigitalSignature: [this.status === SignatureStatus.VALID],
      sameName: [null],
      sameIssuerData: [null],
      sameLeaveDuration: [null],
      requiredDigitalSignature: [null],
    })),
      this.answers.valueChanges.subscribe((values) => {
        if (values.validDigitalSignature) {
          // requiredDigitalSignature can be ignored when validDigitalSignature
          this.requirementsAreMet =
            values.sameName &&
            values.sameIssuerData &&
            values.sameLeaveDuration;
        } else {
          if (values.requiredDigitalSignature) {
            this.requirementsAreMet = false;
          } else {
            this.requirementsAreMet =
              values.sameName &&
              values.sameIssuerData &&
              values.sameLeaveDuration;
          }
        }
      });
  }

  close() {
    this.dialogRef.close();
  }
}

const booleanOptions = [
  { name: 'Sim', value: true },
  { name: 'Não', value: false },
];
